/* eslint-disable */
import styles from './index.module.scss'
import Line from './Line'
import { useContext } from 'react'
import { PageContext } from '../../../context/PageContextProvider'

const StepLine = ({ active, data }) => {
  const { language } = useContext(PageContext)
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>{data?.[active]?.title?.[language] || ''}</h3>
        <p>{data?.[active]?.text?.[language] || ''}</p>
      </div>
      {data?.map((item, i) => (
        <Line
          finished={active >= i}
          active={active === i}
          key={i}
          num={i + 1}
          title={item?.title?.[language] || ''}
          text={item?.text?.[language] || ''}
        />
      ))}
    </div>
  )
}

export default StepLine
